import { fetchCameraData } from './ApiGetCameras';
import { API_SUCCESS, API_FAILED, apiAction } from '../core/apiCoreRedux';
const FETCH_ALL_LOCATIONS = 'FETCH_ALL_LOCATIONS';
const SET_ALL_LOCATIONS = 'SET_ALL_LOCATIONS';
const initialState = [];
const initialAction = {
  type: '',
  payload: []
};

// actions
export const fetchAllLocations = (comapanyId, successCallback = () => { }, failureCallback = () => { }) => ({
  type: FETCH_ALL_LOCATIONS,
  payload: {
    comapanyId,
    successCallback,
    failureCallback
  }
});

export const setAllLocations = (data) => ({
  type: SET_ALL_LOCATIONS,
  payload: data
});

// Middleware
export const fetchAllLocationsMidlleware =
  ({ dispatch }) =>
    (next) =>
      (action) => {
        next(action);
        switch (action.type) {
          case FETCH_ALL_LOCATIONS:
            const { comapanyId, successCallback, failureCallback } = action.payload;
            dispatch(
              apiAction({
                url: `:8989/admin/locations?id=${comapanyId}`,
                actionType: FETCH_ALL_LOCATIONS,
                meta: { successCallback, failureCallback }
              })
            );
            break;

          case `${FETCH_ALL_LOCATIONS} ${API_SUCCESS}`:
            next(setAllLocations(action.payload.locations));
            for (let i = 0; i < action.payload.locations.length; i++) {
              next(fetchCameraData(action.payload.locations[i].id));
            }
            action.meta.successCallback();
            break;

          case `${FETCH_ALL_LOCATIONS} ${API_FAILED}`:
            action.meta.failureCallback();

          default:
          // nothing to be done
        }
      };

// Reducers
export const allLocationsReducer = (state = initialState, action = initialAction) => {
  if (action.type === SET_ALL_LOCATIONS) {
    return action.payload;
  } else {
    return state;
  }
};

// Selectors
export const getAllLocations = (state) => state.allLocations;
